<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-text-field
          label="Min Pax"
          v-model="minPax"
          type="number"
          :outlined="outlinedInputs"
          min="1"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Max Pax"
          v-model="maxPax"
          type="number"
          :outlined="outlinedInputs"
          min="1"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Step"
          v-model="step"
          type="number"
          :outlined="outlinedInputs"
          min="1"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row v-for="item in items" :key="item.uid">
      <v-col
        ><pax-pricing
          :paxFrom="item.paxFrom"
          :paxTo="item.paxTo"
          :items="servicesPricing"
          :accommodations="accommodations"
          @change="onPaxPricingChange"
          :adjustment="adjustmentsForPax(item)"
          @create-itinerary="onShowCreateItinerary"
          :for-itinerary="forItinerary"
          :pax-type="paxType"
        ></pax-pricing>
      </v-col>
    </v-row>
    <div v-if="debug">
      <code>iti input increment: {{ itineraryInput }}</code>
    </div>
    <v-row justify="center"
      ><v-btn color="warning" text class="mx-3" @click="onDelete">Delete</v-btn>
      <v-btn text color="primary" @click="onSave">Save Changes</v-btn></v-row
    >
    <template-settings-dialog
      :show="showCreateItineraryFromTemplate"
      :selected-template="templateData"
      @createItinerary="onCreateItinerary"
      @onCancel="showCreateItineraryFromTemplate = false"
      :initialStartDate="pricingDate"
      create-itinerary
      hide-start-date
      include-settings
    ></template-settings-dialog>
  </v-container>
</template>

<script>
import { ITINERARY_RECALCULATE_MUTATION } from "../../../../../constants/graphql";
import { removeGQLTypename } from "../../../../../helpers";
import { accommodationBucket } from "./helpers";
import PaxPricing from "./PaxPricing";
import TemplateSettingsDialog from "../../TemplateSettingsDialog";
import gql from "graphql-tag";
const moment = require("moment");
const randomize = require("randomatic");
const CREATE_ITINERARY = gql`
  mutation incrementCreateItinerary($input: ItineraryInput!) {
    createItinerary(itineraryInput: $input) {
      id
      reference
    }
  }
`;
export default {
  name: "increment",

  props: {
    increment: {
      type: Object,
      default: () => null,
    },
    templateItems: {
      type: Array,
      default: () => [],
    },
    templateId: {
      type: String,
      default: () => "",
    },
    department: {
      type: String,
      default: () => "FIT",
    },
    destination: {
      type: String,
      default: () => "",
    },
    forItinerary: {
      type: Boolean,
      default: () => false,
    },
    forAdults: {
      type: Boolean,
      default: () => false,
    },
    forChildren: {
      type: Boolean,
      default: () => false,
    },
    forInfants: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { PaxPricing, TemplateSettingsDialog },

  data() {
    return {
      debug: false,
      step: this.increment ? this.increment.step : 2,
      minPax: this.increment ? this.increment.minPax : 1,
      maxPax: this.increment ? this.increment.maxPax : 10,
      pricingDate: this.increment
        ? this.increment.date
        : moment().format("YYYY-MM-DD"),
      itinerary: null,
      adjustments:
        this.increment && this.increment.adjustments
          ? this.increment.adjustments.edges.map(removeGQLTypename)
          : [],
      templateData: {
        id: this.templateId,
        items: this.templateItems,
        destinationId: this.destination,
        department: this.department,
      },
      showCreateItineraryFromTemplate: false,
      itiCharges: [],
      duration: 10,
    };
  },

  computed: {
    paxType() {
      let paxType = "adults";
      if (this.forChildren) {
        paxType = "children";
      } else if (this.forInfants) {
        paxType = "infants";
      }
      return paxType;
    },
    servicesPricing() {
      return this.itinerary && this.itinerary.items
        ? this.itinerary.items.edges.map((item) => {
            return {
              id: item.node.id,
              serviceName: item.node.serviceName,
              rateType: item.node.rateTypeCode,
              price:
                item.node.serviceTypeName == "ACCOMMODATION"
                  ? Number(item.node.totalPrice) /
                    Number(item.node.pax[this.paxType])
                  : Number(item.node.totalPrice),
              serviceTypeName: item.node.serviceTypeName,
              stdOccupancy: Number(item.node.service.stdOccupancy),
              typeName: item.node.service && item.node.service.typeName,
            };
          })
        : [];
    },
    accommodations() {
      const roomTypes = {
        1: "Single",
        2: "Double/Twin",
        3: "Triple",
        4: "Quad",
        100: "Multi Bed",
        200: "Guide",
      };
      const byRoomType = this.servicesPricing
        .filter((item) => item.serviceTypeName == "ACCOMMODATION")
        .reduce((h, item) => {
          const key = accommodationBucket(item.stdOccupancy, item.typeName);
          if (!h[key]) h[key] = [];
          h[key].push(item);
          return h;
        }, {});
      return Object.keys(byRoomType).reduce((rooms, occupancy) => {
        rooms.push({
          name: roomTypes[occupancy],
          occupancy,
          pp: byRoomType[occupancy].reduce(
            (sum, item) => sum + Number(item.price),
            0
          ),
        });

        return rooms;
      }, []);
    },
    itineraryInput() {
      const input = {
        adults: this.increment ? this.increment.maxPax.toString() : "2",
        children: "0",
        infants: "0",
        department: this.department,
        destinationId: this.destination,
        agentId: this.$store.getters.agentId,
        startDate: this.pricingDate,
        endDate: moment(this.pricingDate)
          .add(this.duration, "days")
          .toISOString(),
        participants: [{ name: "TBA", surname: "TBA" }],
        items: this.templateItems.map((templateItem) => {
          const noOfPax =
            templateItem.serviceType == "ACCOMMODATION"
              ? parseInt(templateItem.stdOccupancy)
              : 1;
          const adults = this.forAdults ? noOfPax : 0;
          const children = this.forChildren ? noOfPax : 0;
          const infants = this.forInfants ? noOfPax : 0;
          const qty = 1;
          const itemDay = Number(templateItem.day) - 1;
          let itemStartDate = moment(this.pricingDate)
            .startOf("day")
            .add(itemDay, "days");
          const itemDuration =
            templateItem.serviceType == "ACCOMMODATION"
              ? Number(templateItem.duration)
              : Number(templateItem.duration) - 1;
          let itemEndDate = moment(itemStartDate)
            .startOf("day")
            .add(itemDuration, "days");
          //console.log(templateItem.hasOwnProperty("startDate"), templateItem);
          if (
            templateItem.hasOwnProperty("startDate") &&
            templateItem.hasOwnProperty("endDate")
          ) {
            itemStartDate = templateItem.startDate;
            itemEndDate = templateItem.endDate;
          }
          console.log(templateItem);
          return {
            id: templateItem.uid,
            orderNo: templateItem.orderNo,
            serviceId: templateItem.serviceId,
            startDate: itemStartDate,
            endDate: itemEndDate,
            adults,
            children,
            infants,
            qty,
            customPricing: templateItem.customPricing,
            remarks: templateItem.remarks,
            ratePlan: templateItem.ratePlan,
            pricing: templateItem.customPricing
              ? {
                  adultBuy: templateItem.adultBuy,
                  adultSell: templateItem.adultSell,
                  childBuy: templateItem.childBuy,
                  childSell: templateItem.childSell,
                  infantBuy: 0,
                  infantSell: 0,
                  itemBuy: templateItem.itemBuy,
                  itemSell: templateItem.itemSell,
                  currencyBuy: templateItem.currencyBuy,
                  currencySell: templateItem.currencySell,
                  rateTypeCode: templateItem.rateTypeCode,
                }
              : undefined,
            extras: templateItem.extras.length
              ? templateItem.extras.map((e) => {
                  const extraDay = Number(e.day) - 1;
                  const extraStartDate = moment(this.pricingDate).add(
                    extraDay,
                    "days"
                  );
                  const extraDuration =
                    templateItem.serviceType == "ACCOMMODATION"
                      ? Number(e.duration) + 1
                      : Number(e.duration);
                  const extraEndDate = moment(extraStartDate).add(
                    extraDuration,
                    "days"
                  );
                  return {
                    id: e.extraId,
                    uid: e.extraId,
                    qty: e.qty,
                    startDate: extraStartDate,
                    endDate: extraEndDate,
                  };
                })
              : undefined,
          };
        }),
      };
      return input;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    title() {
      return this.increment
        ? `${this.$options.filters.formatDate(
            this.increment.date
          )} - Min Pax: ${this.increment.minPax}, Max Pax: ${
            this.increment.maxPax
          }`
        : "Increment Title";
    },
    items() {
      if (this.increment) {
        const list = [];
        let n = Number(this.minPax);
        while (n <= Number(this.maxPax)) {
          if (n + Number(this.step) - 1 <= Number(this.maxPax)) {
            list.push({
              uid: `${n}-${n + Number(this.step)}`,
              paxFrom: n,
              paxTo: n + Number(this.step) - 1,
            });
          }
          n += Number(this.step);
        }

        return list;
      } else {
        return [];
      }
    },
  },

  watch: {
    increment(newVal) {
      //console.log(newVal);
      this.minPax = newVal.minPax;
      this.maxPax = newVal.maxPax;
      this.step = newVal.step;
    },
  },

  methods: {
    onShowCreateItinerary(payload) {
      if (this.forItinerary) {
        this.$emit("updateItinerary", payload);
      } else {
        this.itiCharges = [...payload.charges];
        this.showCreateItineraryFromTemplate = true;
      }
    },
    onCreateItinerary(payload) {
      const charges = this.itiCharges.filter(
        (ch) =>
          payload.roomTypes
            .map((rt) => rt.occupancy)
            .indexOf(Number(ch.occupancy)) > -1
      );
      const recalcInput = {
        ...payload.itineraryInput,
        items: [...payload.itineraryInput.items],
      };
      //recalc to get prices
      this.$apollo
        .mutate({
          mutation: ITINERARY_RECALCULATE_MUTATION,
          variables: recalcInput,
        })
        .then(({ data }) => {
          const itiInput = {
            ...recalcInput,
            items: [
              ...data.recalculateItinerary.items.edges
                .map(removeGQLTypename)
                .filter((item) => item.serviceTypeName != "MANDATORY_CHARGES")
                .map(this.fromItiItemToInput)
                .map(this.setZeroPrices),
              ...charges.map(
                this.chargeToItiInput(payload.roomTypes, recalcInput)
              ),
            ],
          };
          this.createItinerary(itiInput);
        })
        .catch((err) => console.error(err));
    },
    setZeroPrices(item) {
      return {
        ...item,
        pricing: {
          adultBuy: item.pricing.adultBuy,
          adultSell: 0,
          childBuy: item.pricing.childBuy,
          childSell: 0,
          infantBuy: item.pricing.infantBuy,
          infantSell: 0,
          itemBuy: item.pricing.itemBuy,
          itemSell: 0,
          rateTypeCode: item.pricing.rateTypeCode,
          currencySell: item.pricing.currencySell,
          currencyBuy: item.pricing.currencyBuy,
        },
      };
    },

    chargeToItiInput(roomTypes, itiInput) {
      return (item) => {
        const roomSettings = roomTypes.find(
          (r) => Number(r.occupancy) == Number(item.occupancy)
        );
        const date = itiInput.endDate; // this.pricingDate;
        //console.log(date, itiInput);
        return {
          id: randomize("Aa0", 32),
          adults: roomSettings ? Number(roomSettings.adults) : 0,
          children: roomSettings ? Number(roomSettings.children) : 0,
          infants: roomSettings ? Number(roomSettings.infants) : 0,
          qty: roomSettings ? Number(roomSettings.qty) : 0,
          startDate: date,
          endDate: date,
          serviceName: item.name,
          serviceType: "MANDATORY_CHARGES",
          serviceId: "",
          isIncluded: true,
          isOptional: false,
          pricing: {
            adultBuy: 0,
            adultSell: item.total,
            childBuy: 0,
            childSell: 0,
            infantBuy: 0,
            infantSell: 0,
            itemBuy: 0,
            itemSell: 0,
            rateTypeCode: "PP",
            currencySell: this.$store.getters.itineraryAgentCurrency,
            currencyBuy: this.$store.getters.itineraryAgentCurrency,
          },
        };
      };
    },
    fromItiItemToInput(item) {
      return {
        id: item.id,
        serviceId: item.service ? item.service.id : "",
        adults: item.pax.adults,
        children: item.pax.children,
        infants: item.pax.infants,
        qty: item.qty,
        startDate: item.startDate,
        endDate: item.endDate,
        serviceType: item.serviceTypeName,
        pricing: { ...item.pricing },
      };
    },
    adjustmentsForPax(item) {
      const adjustment = this.adjustments.find(
        (a) => a.paxFrom == item.paxFrom && a.paxTo == item.paxTo
      );
      if (adjustment) {
        const { id, paxFrom, paxTo, ...adj } = adjustment;
        return { ...adj };
      } else {
        return null;
      }
    },
    onDelete() {
      this.$emit("delete", { ...this.increment });
    },
    onPaxPricingChange(payload) {
      const editedIndex = this.adjustments.findIndex(
        (a) => a.paxFrom == payload.paxFrom && a.paxTo == payload.paxTo
      );
      if (editedIndex > -1) {
        Object.assign(this.adjustments[editedIndex], { ...payload });
      } else {
        this.adjustments.push(payload);
      }
      this.emitChange();
    },
    emitChange() {
      this.$emit("change", {
        id: this.increment.id,
        step: Number(this.step),
        minPax: Number(this.minPax),
        maxPax: Number(this.maxPax),
        adjustments: this.adjustments,
      });
    },
    onSave() {
      this.$emit("update", {
        ...this.increment,
        step: Number(this.step),
        minPax: Number(this.minPax),
        maxPax: Number(this.maxPax),
        adjustments: this.adjustments,
      });
    },
    createItinerary(payload) {
      this.$apollo
        .mutate({
          mutation: CREATE_ITINERARY,
          variables: { input: payload },
        })
        .then(({ data }) => {
          this.showCreateItineraryFromTemplate = false;
          this.$store.dispatch("showAppSnackbar", {
            msg: "Itinerary Created.",
          });
          this.$router.push(`/itinerary/${data.createItinerary.id}/details`);
        })
        .catch((err) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: err,
            color: "error",
          });
          console.error(err);
        });
    },
    async recalculate() {
      try {
        this.loading = true;
        const res = await this.$apollo.mutate({
          mutation: ITINERARY_RECALCULATE_MUTATION,
          variables: this.itineraryInput,
        });
        //console.log("recalc response", res.data.recalculateItinerary);
        this.itinerary = { ...res.data.recalculateItinerary };

        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
  },

  mounted() {
    this.recalculate();
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/increments/Increment.vue